export default {
  recover_success: 'Recover Success',
  Please_check_your_mail_inbox:'Please, check your mail inbox',
  We_saved_new_password: 'We Saved new password',
  login_by_email_or_username:'login by email or username'
}
